import React from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { Loader } from '@eika/loader';

import ErrorIcon from '../icons/ErrorIcon';

export const SavingMessage = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div className="save-indicator" {...props}>
        <div className="icon">
            <Loader mini />
        </div>
        <div className="text">
            <p>Lagrer...</p>
        </div>
    </div>
);

export const SavedMessage = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div className="save-indicator" {...props}>
        <div className="icon">
            <CheckmarkAnimation mini />
        </div>
        <div className="text">
            <p>Lagret</p>
        </div>
    </div>
);

export const SavingFailedMessage = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div className="save-indicator" {...props}>
        <div className="icon">
            <ErrorIcon />
        </div>
        <div className="text">
            <p>Ikke lagret</p>
        </div>
    </div>
);
